import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { Divider, Pressable, Text } from "native-base";
import { formatMeasuredAt, formatMeasuredAtShort } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Tooltip from "./Tooltip";
import { boxShadow, colors, tooltipCoordContentBox, tooltipCoordManualTag, tooltipCoordText, } from "./useStyles";
export default function TooltipCoord({ tooltip = {
    displayValue: "",
    msec: 0,
    note: "",
    isManual: false,
    type: "",
    isGrouped: false,
    group: [],
}, }) {
    const { type = "", displayValue = "", msec = 0, note = "", isManual = false, isGrouped = false, group = [], } = tooltip;
    const styleTitle = {
        color: colors.black,
        fontSize: 16,
        fontWeight: "500",
        lineHeight: 24,
        marginBottom: 2,
    };
    const styleLink = {
        color: colors.green500,
        fontSize: 14,
        fontWeight: "500",
        lineHeight: 24,
        whiteSpace: "nowrap",
        marginTop: 4,
    };
    const groupedItemTitle = {
        color: colors.black,
        fontSize: 14,
        lineHeight: 21,
        fontWeight: "500",
    };
    const boxWidth = {
        width: isGrouped ? 200 : 150,
    };
    const [groupLength, setGroupLength] = useState(4);
    const { t } = useTranslation();
    return (_jsx(Tooltip, Object.assign({ tooltip: tooltip, styleArrow: { borderTopColor: colors.white }, styleContentBox: Object.assign(Object.assign(Object.assign({}, tooltipCoordContentBox), boxShadow), boxWidth), needsArrow: false }, { children: isGrouped && (group === null || group === void 0 ? void 0 : group.length) > 0 ? (_jsxs(_Fragment, { children: [group.map((item, index) => {
                    if (index < groupLength) {
                        return (_jsxs(Fragment, { children: [_jsx(Text, Object.assign({ style: [
                                        tooltipCoordText,
                                        groupedItemTitle,
                                    ] }, { children: item.displayValue })), _jsx(Text, Object.assign({ style: tooltipCoordText }, { children: formatMeasuredAt(item.administeredAt) })), _jsx(Divider, { thickness: 0, mb: 2 })] }, `${item.displayValue} ${index}`));
                    }
                }), group.length > groupLength && (_jsx(Pressable, Object.assign({ onPress: () => setGroupLength(group.length) }, { children: _jsx(Text, Object.assign({ style: [tooltipCoordText, styleLink] }, { children: t("measures:viewAllGroup", {
                            count: group.length,
                        }) })) })))] })) : (_jsxs(_Fragment, { children: [_jsx(Text, Object.assign({ style: [tooltipCoordText, styleTitle] }, { children: displayValue })), _jsx(Text, Object.assign({ style: tooltipCoordText }, { children: type === "column"
                        ? formatMeasuredAtShort(msec)
                        : formatMeasuredAt(msec) })), _jsx(Text, Object.assign({ style: tooltipCoordText }, { children: note })), isManual && (_jsx(Text, Object.assign({ style: tooltipCoordManualTag }, { children: t("measures:manual").toUpperCase() })))] })) })));
}
